module.exports = __webpack_public_path__ + "img/project3_small.f03e9df5.jpg";